import { Alert } from "@mui/material";
import { useState } from "react";

interface CustomErrorProps {
	error: string;
}

export const useCustomError = ({ error }: CustomErrorProps) => {
	const [showError, setShowError] = useState(false);

	const renderError = () => {
		return showError ? (
			<Alert
				severity="error"
				sx={{ alignItems: "center", bgcolor: "error.light", fontSize: 14, marginTop: 2 }}
			>
				{error}
			</Alert>
		) : (
			""
		);
	};

	return {
		renderError,
		setShowError,
	};
};
